var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-wrap"},[_c('img',{attrs:{"src":require("@/assets/images/index/sys-error.png")}}),_c('p',[_vm._v(_vm._s(_vm.siteInfo.close_reason || '抱歉！系统发生异常！'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }